// Super SA

// Make sure any image references are for images located in "public/img"

export default {
  settings: {
    disableIframePostMessage: false,
  },

  defaults: {
    // Need to set these to the required amount, even if not giving the user an option to change them
    // e.g. Super SA *only* offer 2 months of 75% cover.
    age: 45,
    annualIncome: 80000,
    gender: 'male',
    coverAmount: 0.75,
    benefitPeriod: 2,
    waitingPeriod: 90,
  },

  content: {
    general: {
      websiteUrl: "https://www.supersa.sa.gov.au/",
      modellerName: "Income Protection Insurance",

      tabLabels: {
        welcomeTab: "Welcome",
        calculationTab: "Get a quote",
        whatsNextTab: "What's next?",
      },

      disclaimer: `<p>
      This calculator has been provided to you by Super SA. The estimate produced by this calculator is based on details
      you enter and can assist to work out the cost of insurance for Super SA members from 1 July 2022. None of the details
      you enter into this calculator are retained or saved by Super SA. For information about our insurance cover,
      including any eligibility, fees and terms and conditions, refer to the relevant Product Disclosure Statement (PDS)
      and fact sheets which are available on our website. Please note that this calculator is for illustrative purposes
      only. Although Super SA endeavours to ensure that the calculations are accurate, we cannot guarantee its accuracy
      and your entitlements remain those which are determined in accordance with the <em>Southern State Superannuation Act
      2009</em> and Regulations. No responsibility will be accepted for any errors or omission. If you make any changes
      to your insurance cover it may be subject the provision of medical evidence. You have the option to change,
      review or cancel your insurance at any time. Before making any financial decisions consider your own financial
      circumstances, needs and objectives and we recommend you seek professional financial advice.
      </p>`,
    },

    welcome: {
      bannerHeading: `<h1>Income Protection Insurance</h1>`,
      alternateHeadingPosition: true,
      header: `<h3>Need a quick free quote?</h3>`,
      content: `<br />
      <p>Income protection gives you peace of mind knowing that you can still cover the bills if you become ill or injured and unable to work.</p>
      <p>In just one minute, get a fortnightly cost for Income Protection insurance.</p>
      <br />`,
      buttonLabel: "Start Here",
    },

    calculation: {
      header: "This insurance provides you with an income for up to two years up to age 65, if you can't work due to illness or injury.",
      resultHeader: "Your income protection benefit",
      benefitPeriod: "per fortnight (before tax)",
      costPeriod: "Per fortnight",
      showSuperBenefit: true,

      hideUnitResults: true,

      ageLabel: "Your age",

      hideGender: true,
      //genderLabel: "Gender",

      annualIncomeLabel: "Your annual salary",
      annualIncomeTooltip: "Salary is before tax, that your SA government employer pays to you annually. For non-full-time employment, up to 3-year averaging of salary for benefits would be applied.",

      protectionCoverLabel: " ",

      hideCoverAmount: true,
      hideBenefitPeriod: true,

      waitingPeriodLowerLimit: 30,
      waitingPeriodUpperLimit: 90,
      waitingPeriodLabel: "Waiting period",
      showWaitingPeriodTooltip: true,
      waitingPeriodTooltip: "A 90 day waiting period means lower premiums, but you will wait 90 days instead of 30 days to receive benefit payments.",

      calculateButtonLabel: "Calculate",
      reCalculateButtonLabel: "Recalculate",
      printButtonLabel: "Print",
      nextButtonLabel: "Next",
    },

    whatsnext: {
      showMiddleContent: true,
      heading: `<h2 class="whats-next-title">We're here to help</h2>
        <br /><p>Income Protection gives you the freedom to focus on your recovery, without the worry of bills piling up.</p>`,
      leftColContent: `<div class="cta-box light-bg">
        <div class="cta-icon">
          <img src="img/super-sa/contact-us.svg" alt="Apply now">
        </div>
        <div class="cta-title">
          <h4>
            Getting in touch
          </h4>
        </div>
        <p>We can answer your questions and help you apply.
        </p>
        <a
          color="primary"
          class="btn btn-primary"
          href="https://www.supersa.sa.gov.au/contact-us/"
          target="_blank"
        >
          Contact us

        </a>
      </div>`,
      middleColContent: `<div class="cta-box light-bg">
      <div class="cta-icon">
        <img src="img/super-sa/member-online.svg" alt="Apply now">
      </div>
      <div class="cta-title">
        <h4>
          Check your cover
        </h4>
      </div>
      <p>
        If you have insurance with Super SA, log into the Member Portal to view the details.
      </p>
      <a
        color="primary"
        class="btn btn-primary"
        href="https://entprod.supersa.sa.gov.au/member/login/"
        target="_blank"
      >
        Check now

      </a>
    </div>`,
      rightColContent: `<div class="cta-box light-bg">
        <div class="cta-icon">
          <img src="img/super-sa/insurance-level.svg" alt="Apply now">
        </div>
        <div class="cta-title">
          <h4>
            Learn more
          </h4>
        </div>
        <p>
          If you're unsure about what cover is right for you or how much you will need, we're here to help.
        </p>
        <a
          color="primary"
          class="btn btn-primary"
          href="https://www.supersa.sa.gov.au/insurance/income-protection/"
          target="_blank"
        >
          Find out more

        </a>
      </div>`,
    },
  },

  analytics: {
    gacode: "G-GHBN8EMT68"
  },



  /*
  * Functionality uses same process as Excel VLOOKUP
  */

  insurancePremiumData: {
    quoteData: {
      // Use vLookup Function
      incomeProtection2: {
        waitingPeriod30: [
          {"age": 15, "rate": 0.16},
          {"age": 16, "rate": 0.16},
          {"age": 17, "rate": 0.16},
          {"age": 18, "rate": 0.16},
          {"age": 19, "rate": 0.16},
          {"age": 20, "rate": 0.16},
          {"age": 21, "rate": 0.16},
          {"age": 22, "rate": 0.16},
          {"age": 23, "rate": 0.16},
          {"age": 24, "rate": 0.16},
          {"age": 25, "rate": 0.16},
          {"age": 26, "rate": 0.16},
          {"age": 27, "rate": 0.17},
          {"age": 28, "rate": 0.17},
          {"age": 29, "rate": 0.17},
          {"age": 30, "rate": 0.17},
          {"age": 31, "rate": 0.17},
          {"age": 32, "rate": 0.18},
          {"age": 33, "rate": 0.18},
          {"age": 34, "rate": 0.19},
          {"age": 35, "rate": 0.20},
          {"age": 36, "rate": 0.21},
          {"age": 37, "rate": 0.21},
          {"age": 38, "rate": 0.23},
          {"age": 39, "rate": 0.24},
          {"age": 40, "rate": 0.26},
          {"age": 41, "rate": 0.27},
          {"age": 42, "rate": 0.28},
          {"age": 43, "rate": 0.31},
          {"age": 44, "rate": 0.33},
          {"age": 45, "rate": 0.35},
          {"age": 46, "rate": 0.37},
          {"age": 47, "rate": 0.39},
          {"age": 48, "rate": 0.43},
          {"age": 49, "rate": 0.46},
          {"age": 50, "rate": 0.49},
          {"age": 51, "rate": 0.52},
          {"age": 52, "rate": 0.56},
          {"age": 53, "rate": 0.63},
          {"age": 54, "rate": 0.70},
          {"age": 55, "rate": 0.78},
          {"age": 56, "rate": 0.85},
          {"age": 57, "rate": 0.93},
          {"age": 58, "rate": 0.97},
          {"age": 59, "rate": 1.07},
          {"age": 60, "rate": 1.07},
          {"age": 61, "rate": 1.11},
          {"age": 62, "rate": 1.16},
          {"age": 63, "rate": 1.02},
          {"age": 64, "rate": 0.44}
        ],
        waitingPeriod90: [
          {"age": 15, "rate": 0.09},
          {"age": 16, "rate": 0.09},
          {"age": 17, "rate": 0.09},
          {"age": 18, "rate": 0.09},
          {"age": 19, "rate": 0.09},
          {"age": 20, "rate": 0.09},
          {"age": 21, "rate": 0.09},
          {"age": 22, "rate": 0.09},
          {"age": 23, "rate": 0.09},
          {"age": 24, "rate": 0.09},
          {"age": 25, "rate": 0.09},
          {"age": 26, "rate": 0.09},
          {"age": 27, "rate": 0.09},
          {"age": 28, "rate": 0.09},
          {"age": 29, "rate": 0.09},
          {"age": 30, "rate": 0.09},
          {"age": 31, "rate": 0.10},
          {"age": 32, "rate": 0.10},
          {"age": 33, "rate": 0.10},
          {"age": 34, "rate": 0.10},
          {"age": 35, "rate": 0.11},
          {"age": 36, "rate": 0.11},
          {"age": 37, "rate": 0.12},
          {"age": 38, "rate": 0.13},
          {"age": 39, "rate": 0.13},
          {"age": 40, "rate": 0.14},
          {"age": 41, "rate": 0.15},
          {"age": 42, "rate": 0.16},
          {"age": 43, "rate": 0.17},
          {"age": 44, "rate": 0.18},
          {"age": 45, "rate": 0.19},
          {"age": 46, "rate": 0.20},
          {"age": 47, "rate": 0.22},
          {"age": 48, "rate": 0.23},
          {"age": 49, "rate": 0.25},
          {"age": 50, "rate": 0.27},
          {"age": 51, "rate": 0.29},
          {"age": 52, "rate": 0.31},
          {"age": 53, "rate": 0.35},
          {"age": 54, "rate": 0.39},
          {"age": 55, "rate": 0.43},
          {"age": 56, "rate": 0.47},
          {"age": 57, "rate": 0.51},
          {"age": 58, "rate": 0.54},
          {"age": 59, "rate": 0.56},
          {"age": 60, "rate": 0.59},
          {"age": 61, "rate": 0.61},
          {"age": 62, "rate": 0.64},
          {"age": 63, "rate": 0.56},
          {"age": 64, "rate": 0.24}
        ]
      }
    },

    params: {
      calculationMethod: 'supersa',
      salaryBenefitRate: 0.75,
      superBenefitRate: 0.1,
      ipBenefitRate: 0.095,
      minAge: 16,
      maxAge: 64,
      minSalary: 0,
      maxSalary: 584000,
      salaryStep: 2000,
      maxIncome75: 48000, // Not used?
      maxIncome85: 423529 // Not used?
    },
    lastUpdated: "1 July 2019"
  }
};